import { HStack } from '@cdl/heartbeat-react';
import { Fragment } from 'react';
import { getApplicationPath } from '../../ecg/utils/application-path.utils';
import { useToolbox } from '../hooks/useToolbox';
import { useMetrics } from '../../metric/hooks/useMetrics';
import { PatientInfo } from './PatientInfo';
import { useSelector } from 'react-redux';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { ZoomNoiseToolbox } from './ZoomNoiseToolbox';

export const TOOLBOX_HEIGHT = '3.244rem';

export const Toolbox = () => {
  const path = getApplicationPath(window.location);
  const tools = useToolbox(path);
  const metrics = useMetrics(path);
  const withPatientInfo = useSelector(
    getLayoutValueSelector('withPatientInfo'),
  );
  const isZoomNoisePath = path === 'zoom-noise';

  return isZoomNoisePath ? (
    <ZoomNoiseToolbox />
  ) : (
    <HStack
      spacing={0}
      justifyContent='space-between'
      alignItems='stretch'
      gap='s'
      wrap='wrap'
      minHeight={TOOLBOX_HEIGHT}
      data-testid='toolbox'
    >
      <HStack spacing='s' alignItems='stretch'>
        {metrics}
        {withPatientInfo && <PatientInfo />}
      </HStack>
      <HStack
        bgColor='neutral.0'
        spacing='xs'
        p='xs'
        borderRadius='4px'
        shadow={400}
      >
        {tools.map((tool, index) => (
          <Fragment key={index}>{tool}</Fragment>
        ))}
      </HStack>
    </HStack>
  );
};
